import { isDefined, RuntimeNotifier, tryCatch } from "@opendaw/lib-std";
import { Promises } from "@opendaw/lib-runtime";
export var Fullscreen;
(function (Fullscreen) {
    Fullscreen.isAvailable = (element) => element.ownerDocument.fullscreenEnabled && isDefined(element.requestFullscreen);
    Fullscreen.request = async (element) => {
        if (!Fullscreen.isAvailable(element)) {
            await RuntimeNotifier.info({
                headline: "Fullscreen Unavailable",
                message: "Fullscreen is disabled or not supported in this browser.",
                origin: element
            });
            return false;
        }
        // extensions may replace requestFullscreen with a wrapper that throws instead of rejecting
        const call = tryCatch(() => element.requestFullscreen());
        const result = call.status === "success" ? await Promises.tryCatch(call.value) : call;
        if (result.status === "resolved") {
            return true;
        }
        await RuntimeNotifier.info({
            headline: "Fullscreen Error",
            message: "The browser refused to enter fullscreen.",
            origin: element
        });
        return false;
    };
    Fullscreen.toggle = async (element) => {
        const document = element.ownerDocument;
        if (isDefined(document.fullscreenElement)) {
            await Promises.tryCatch(document.exitFullscreen());
            return false;
        }
        return Fullscreen.request(element);
    };
})(Fullscreen || (Fullscreen = {}));
